var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMainIcon = function SvgMainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15171D",
    strokeWidth: 1.754,
    d: "M.877.877h22.804v22.804H.877z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.681,
    height: 23.681,
    x: 0.439,
    y: 0.439,
    fill: "#15171D",
    strokeWidth: 0.877,
    rx: 3.07
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.681,
    height: 23.681,
    x: 0.439,
    y: 0.439,
    fill: "#15171D",
    strokeWidth: 0.877,
    rx: 3.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    strokeWidth: 1.063,
    d: "M-.815-9.062c11.918 0 21.58 9.662 21.58 21.58 0 11.919-9.662 21.58-21.58 21.58-11.919 0-21.58-9.661-21.58-21.58s9.661-21.58 21.58-21.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    strokeWidth: 1.063,
    d: "M16.634-.143a21.05 21.05 0 0 1 .717 24.311h-2.64a80 80 0 0 0 1.844-2.384 117 117 0 0 0 1.208-1.65l.072-.102.019-.027.005-.007.002-.002.601-.847-1.039.008-.428.003-.16.002-.131.087a8.6 8.6 0 0 1-4.803 1.456H11.9c-4.64 0-8.36-3.593-8.36-7.975s3.72-7.974 8.36-7.974a8.6 8.6 0 0 1 4.771 1.43l.132.089h.158l.478.004.814.006-.322-.748v-.001l-.002-.003-.004-.008-.012-.029-.047-.102q-.063-.136-.19-.384c-.17-.33-.427-.805-.787-1.393a32 32 0 0 0-2.719-3.76zm-4.34 6.756c-3.736 0-6.897 2.68-6.897 6.117s3.16 6.117 6.897 6.117c3.426 0 6.253-2.244 6.724-5.247l.003-.019.002-.018q.044-.486.06-.993v-.036c-.116-3.332-3.113-5.921-6.79-5.921Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.79,
    height: 23.79,
    x: 0.384,
    y: 0.384,
    strokeWidth: 0.767,
    rx: 3.125
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(172.172 10.22 6.988)scale(46.8997 43.2035)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#5FD4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#FEF7D8",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD9CF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.558,
    height: 24.558,
    fill: "#fff",
    rx: 3.4
  })))));
};
export default SvgMainIcon;